<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="100"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from "../mixin";
import {
    HttpSaveImporter,
    HttpImporterGetOne
} from "@/service/logistics";
export default {
  mixins: [mixin],
  props: ["activeid","type"],
  created() {
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      addressCodeList:[],
      formData: {
        status:0,
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getCountryList']),
       
      isAdd() {
        return this.type === 'add'
      },
       isQuery() {
          return this.type === "query";
      },
        
     getBase() {
			return [{
              label: this.$t('fbb.headlogistics.import_name',{defaultValue:'进口商名称'}),
              key: "name",
              tag:'vInput',
              query:this.isQuery,
              },{
              label: this.$t('erp.channelbase.country',{defaultValue:'国家'}),
              key: "country",
              tag:'Select',
              query:this.isQuery,
              options:this.getCountryList,
              },{
              label: this.$t('fbb.headlogistics.address_detail',{defaultValue:'详细地址'}),
              key: "address",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('fbb.headlogistics.receiver',{defaultValue:'收货人'}),
              key:"receiverName",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('global.common.mobile',{defaultValue:'移动电话'}),
              key: "phone",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('fbb.headlogistics.receiver_telephone',{defaultValue:'固定电话'}),
              key: "telephone",
              query:this.isQuery,
              required:false,
              tag:'vInput',
              },{
              label: this.$t('fbb.headlogistics.receiver_fax',{defaultValue:'传真'}),
              key: "fax",
              query:this.isQuery,
              required: false,
              tag:'vInput',
              },{
              label: this.$t('fbb.headlogistics.receiver_note',{defaultValue:'其他联系方式'}),
              key: "other",
              query:this.isQuery,
              required: false,
              tag:'vInput',
              },{
              label: this.$t('global.common.status',{defaultValue:'状态'}),
              key: "status",
              query:this.isQuery,
              tag:'Select',
              options:this.getImporterStatus,
              }
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpImporterGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          	this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        this.loading = true;
        HttpSaveImporter({
         ...this.formData
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
